import { Validator } from ".";
import { BaseRule } from "./BaseRule";
import { RangeRule, RegexRule, RequiredRule } from "./Rules";

class ValidatorsFactory {

	static validatorsFunc = {
		// правила валидации задаваемые типом поля
		// 'datetime': datetimeRule,
		// 'datetime?': datetimeRule,
		// 'int': intRule,
		// 'int?': intRule,
		// 'int32': intRule,
		// 'int32?': intRule,
		// 'int64': intRule,
		// 'int64?': intRule,
		// 'double': doubleRule,
		// 'double?': doubleRule,
		// 'decimal': doubleRule,
		// 'decimal?': doubleRule,
		// 'bool': boolRule,
		// 'bool?': boolRule,
		// 'boolean': boolRule,
		// 'boolean?': boolRule,
		// 'files': filesRule,
		//'fias': modelRule,
		// 'model': modelRule,
		//правила валидации задаваемые атрибутами
		required: RequiredRule,
		range: RangeRule,
		// 'regularexpression': regexRule,
		// 'stringlength': stringLengthRule,
		// 'lessthannow': lessThanNowRule,
	};

	static getValidationRule = ( validationType: string, errorMessage: string, validationParameters: any ) => {
		const func = (this.validatorsFunc as any)[validationType];
		return func ? ( new func(validationType, errorMessage, validationParameters) ) : null;
	};

	static getValidationRules = ( colDef: any ) => {
		const rules = [];
		const validator = colDef.validator;
		if ( validator ) {
			let validationRules;
			if (Object.prototype.toString.call(colDef.validator.rules) === '[object Array]') {
				validationRules = colDef.validator.rules;
			} 
			else {
				validationRules = [];
			}
			for ( let i = 0; i < validationRules.length; i++ ) {
				const ruleDesc = validationRules[i];
				const rule = this.getValidationRule(ruleDesc.validationType.toLowerCase(), ruleDesc.errorMessage, ruleDesc.validationParameters);
				if (rule)
					rules.push(rule);
				//else
				//    console.warn('среди клиентских правил валидации не найдено правило типа ' + ruleDesc.validationType);
			}
		}
		return rules;
	};

	static getComplexValidator = ( colDef: any ) => {
		const rules = this.getValidationRules(colDef);
		return new Validator( rules );
	};

	static getRequiredValidator = ( errorMessage: string = "" ) => {
		const rule = new RequiredRule( errorMessage );
		return new Validator( [rule] );
	};

	static getRegexValidator = ( pattern: RegExp, errorMessage: string ) => {
		const rule = new RegexRule( errorMessage, pattern );
		return new Validator([rule]);
	};

	static getComplexValidatorForValidators = ( validators: Array<Validator> ) => {
		const rules: BaseRule[] = [];
		for (let index = 0; index < validators.length; index++) {
			const element = validators[index].rules;
			rules.push( ...element );
		}
		return new Validator(rules);
	};

};

export default ValidatorsFactory;
